<template>
    <div class="my-course-shell">
        <div class="coupon-tab-list">
            <div class="coupon-tab-box" :class="{'coupon-tab-box-active': item.code==tab_code}"
                 v-for="(item,index) in tab_list" :key="index" @click.stop="cut_tab(item,index)">
                {{item.name}}
            </div>
        </div>
        <div class="course-list" v-if="tab_code==1 || tab_code==5 || tab_code==6">
            <div class="goods-box" v-for="(item,index) in course_list" :key="index">
                <div class="goods-info">
                    <div class="course-img">
                        <img v-if="item.course_type==2" :src="item.course_img" alt=""/>
                        <img v-else-if="item.course_type==4" :src="item.course_img" alt=""/>
                        <img v-else :src="item.course_info.course_img" alt=""/>
                    </div>
                    <div class="info">
                        <div class="course-name">
                            {{item.course_type==2||item.course_type==4?item.course_name:item.course_info.course_name}}
                        </div>
                        <div class="course-type">
                            类别：
                            <span>{{item.course_type==2||item.course_type==4?type:item.course_type_text?item.course_type_text:item.course_type}}</span>
                        </div>
                        <div class="course-time" v-if="item.course_type==2">专业科目：{{item.total_period}}学时</div>
                        <div class="course-time" v-else-if="item.course_type==4">公需科目：30学时</div>
                        <div class="course-time" v-else>学时：{{item.course_info.cnt_course}}学时</div>
                        <div class="course-time"> 时间：<span>{{item.add_time}}</span></div>
                    </div>
                </div>
                <div class="goods-bottom-handle">
                    <div class="course-bar-shell" v-if="item.is_record">
                        <div class="course-bar-tips" v-if="item.learn_rate || item.learn_rate==0">学习进度：
                            {{(item.learn_rate).toFixed(2)}}%
                        </div>
                        <div class="course-bar-tips" v-else>学习进度： {{item.learn_num/item.cnt_num*100}}%</div>
                        <div class="course-bar">
                            <div class="bar" :style="'width:'+item.learn_rate+'%'"
                                 v-if="item.learn_rate || item.learn_rate==0"></div>
                            <div class="bar" :style="'width:'+item.learn_num/item.cnt_num*100+'%'" v-else></div>
                        </div>
                    </div>
                    <div class="course-bar-shell" v-else></div>
                    <div class="handle-list" v-if="item.course_type==2">
                        <el-button round type="danger"
                                   @click.stop="handleItem(item)">开始学习
                        </el-button>
                        <!-- <el-button round type="success"
                                   @click="$router.push('/simulativeTset?belong=0&qst_id='+item.qst_id)">模拟练习
                        </el-button> -->
                        <el-button round type="success" style="margin-left: 20px"
                          @click="$router.push('/kaoshi?year='+item.course_name.slice(0, 4))">模拟练习
                        </el-button>
                        <el-button round type="warning" @click.stop="applet_show=true">药师考核</el-button>
                        <el-button round type="primary" v-if="item.total_period < 60" @click.stop="handleLink(item)">再次选课</el-button>
                    </div>
                    <div class="handle-list" v-else-if="item.course_type==4">
                        <el-button round type="danger"
                                   @click.stop="handlePublic(item)">开始学习
                        </el-button>
                    </div>
                    <div class="handle-list" v-else>
                        <el-button round type="danger"
                                   @click.stop="$router.push('/Gostudy?course_id='+item.course_info.course_id)">开始学习
                        </el-button>
                        <el-button round type="success" v-if="item.parent_cate==42"
                                   @click="$router.push('/simulativeTset')">模拟练习
                        </el-button>
                        <el-button round type="warning" @click.stop="applet_show=true" v-if="item.parent_cate==42">
                            正式考核
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="course-list" v-if="tab_code==2">
            <div class="course-box1" v-for="(item,index) in course_list" :key="index">
                <div class="course-img">
                    <img :src="item.course_img" alt=""/>
                </div>
                <div class="course-info">
                    <div class="course-name">
                        {{item.course_name}}
                    </div>
                    <div class="course-price">
                        ￥{{item.course_price}}
                    </div>
                    <div class="course-type">
                        类别：
                        <span>{{item.course_type==2?'药师课程':item.course_type_text?item.course_type_text:item.course_type}}</span>
                    </div>
                    <div class="course-time">
                        学时：
                        <span>{{item.cnt_course}}课时</span>
                    </div>
                </div>
                <div class="info-right">
                    <div class="buy-btn" @click.stop="$router.push('/Purchase?course_id='+item.course_id)"
                         v-if="!item.buy_status">
                        立即购买
                    </div>
                    <div class="buy-btn" @click.stop="$router.push('/Gostudy?course_id='+item.course_id)"
                         v-if="item.buy_status">
                        开始学习
                    </div>
                </div>
            </div>
        </div>
        <div class="course-list" v-if="tab_code==3">
            <div class="course-box1" v-for="(item,index) in course_list" :key="index">
                <div class="course-img">
                    <img :src="item.course_img" alt=""/>
                </div>
                <div class="course-info">
                    <div class="course-name">
                        {{item.course_name}}
                    </div>
                    <div class="course-type">
                        类别：
                        <span>{{item.course_type==2?'药师课程':item.course_type_text?item.course_type_text:item.course_type}}</span>
                    </div>
                    <div class="course-time">
                        学时：
                        <span>{{item.cnt_course}}课时</span>
                    </div>
                    <!--                    <div class="course-bar-shell">-->
                    <!--                        <div class="course-bar-tips">学习进度： 90%</div>-->
                    <!--                        <div class="course-bar">-->
                    <!--                            <div class="bar"></div>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                </div>
                <div class="info-right">
                    <div class="start-btn"
                         @click.stop="$router.push('/Gostudy?course_id='+item.course_id +'&type=company')">开始学习
                    </div>
                </div>
            </div>
        </div>
        <!--        <Golearn v-if="tab_code==4"></Golearn>-->
        <NoData v-if="course_list.length<1 && tab_code!=4" width="168px" height="235px"></NoData>
        <div class="paging-shell" v-if="tab_code!=4">
            <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-size="page_size"
                    background layout="prev, pager, next" :total="course_total"></el-pagination>
        </div>
        <div class="applet-popup-shell" v-show="applet_show" @click.stop="applet_show=false">
            <div class="popup-content-shell" @click.stop="">
                <div class="popup-title">请使用手机扫码进入小程序进行考核</div>
                <img src="@/assets/applet-kaohe.jpg" alt="" class="applet-img"> 
                <div class="ass-nav">考核提示</div>
                <div class="ass-title"><span>考核平台属省药监局，</span>如果出现以下提示，请到省局平台https://yaoshi.hnmpaed.com/处理。</div>
                <div class="ass-msg">1.<span>出现“账号或密码错误”</span>，请进省局平台首页-“药师登录”（用手机验证码登录）-“个人信息”修改密码确认后提交。</div>
                <div class="ass-msg">2.<span>出现“请确保是本人后”</span>，2.请进省局平台首页-“药师登录”-“更换头像”，照片要求：背靠白墙，请别人拍一张肩部以上的照片，裁剪成头部大小。</div>
                <div class="ass-btn" @click.stop="applet_show=false">我知道了</div>
            </div>
        </div>
    </div>
</template>

<script>
  import NoData from '@/components/no-data.vue'
  // import Golearn from '@/views/home/Golearn/index.vue'
  export default {
    name: 'my-course',
    components: {
      NoData,
      // Golearn
    },
    data () {
      return {
        applet_show: false,
        course_total: 0,
        course_list: [],
        tab_list: [
          {
            name: '已报课程',
            code: 1
          },
          {
            name: '收藏课程',
            code: 2
          },
          // {
          //   name: '单位课程',
          //   code: 3
          // },
          // {
          //   name: '药师课程',
          //   code: 4
          // },
          {
            name: '已学完',
            code: 5
          },
          {
            name: '未学完',
            code: 6
          },
        ],
        tab_code: 1,
        page_size: 3,
        pageIndex: 1,
        type: '',
      }
    },
    mounted () {
      this.handleCurrentChange(1)
      let info = localStorage.getItem("user_info")
      this.type = JSON.parse(info).leixing
    },
    methods: {
      cut_tab (item) {
        this.pageIndex = 1
        this.tab_code = item.code
        this.course_list = []
        this.handleCurrentChange(1)
      },
      // 我的课程
      get_course_list () {
        // this.API.post('user/course_in-mine_course_list', {
        this.API.post('user/course_in-enroll_course', {
          page: this.pageIndex,
          page_size: this.page_size
        }).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          this.course_total = res.data.cnt_course
          this.course_list = res.data.course_list
        })
      },
      // 收藏的课程列表
      get_collect_list () {
        this.API.post('user/course_in-collect_course_list', {
          page: this.pageIndex,
          page_size: this.page_size
        }).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          this.course_list = res.data.course_list
          this.course_total = res.data.cont_course
        })
      },
      // 单位课程
      get_company_list () {
        this.API.post('user/course_in-company_list', {
          page: this.pageIndex,
          page_size: this.page_size
        }).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          this.course_total = res.data.cont_course
          if (res.data.course_list) {
            this.course_list = res.data.course_list
          }
        })
      },
      get_end_list () {
        this.API.post('user/course_in-finsh_course', {
          page: this.pageIndex,
          page_size: this.page_size
        }).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          this.course_total = res.data.cnt_course
          if (res.data.course_list) {
            this.course_list = res.data.course_list
          }
        })
      },
      handleItem (item) {
        this.API.post("Home/course_out-study_end", {}).then(res => {
          if (res.data.state == 1) {
            this.$confirm('<div style="text-align:left">接省药监局通知,执业药师继续教育<span style="color:red">学习平台和报名通道</span>于2023年7月12日下午18:00起同步<span style="color:red">关闭进行系统升级</span>，预计下周同时开启。</div>', '温馨提示', {
              dangerouslyUseHTMLString: true,
              center: true,
              showCancelButton: false,
              confirmButtonText: '知道了',
            })
          } else {
            this.$router.push('/Gostudy?course_type=2&course_id='+item.course_id)
          }
        })
      },
      handlePublic (item) {
        this.API.post("Home/course_out-study_end", {}).then(res => {
          if (res.data.state == 1) {
            this.$confirm('<div style="text-align:left">接省药监局通知,执业药师继续教育<span style="color:red">学习平台和报名通道</span>于2023年7月12日下午18:00起同步<span style="color:red">关闭进行系统升级</span>，预计下周同时开启。</div>', '温馨提示', {
              dangerouslyUseHTMLString: true,
              center: true,
              showCancelButton: false,
              confirmButtonText: '知道了',
            })
          } else {
            this.$router.push('/PublicList?year='+item.phar_year)
          }
        })
      },
      handleLink (item) {
        this.API.post("login/user_acc-phar_choose", { phar_id: item.info_id }).then(
          (res) => {
            localStorage.setItem("token", res.data.token);
            this.$router.push("/pharmacist-course?total_period=" +  item.total_period);
          }
        );
      },
      get_ing_list () {
        this.API.post('user/course_in-unfinsh_course', {
          page: this.pageIndex,
          page_size: this.page_size
        }).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          this.course_total = res.data.cnt_course
          if (res.data.course_list) {
            this.course_list = res.data.course_list
          }
        })
      },
      handleCurrentChange (val) { // 页数操作
        this.pageIndex = val
        switch (this.tab_code) {
          case 1:
            this.get_course_list()
            break
          case 2:
            this.get_collect_list()
            break
          case 3:
            this.get_company_list()
          case 5:
            this.get_end_list()
            break
          case 6:
            this.get_ing_list()
            break
        }
      }
    }
  }
</script>

<style lang="less" scoped>
    .my-course-shell {

    }

    .applet-popup-shell {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: 0px;
        left: 0px;
        background-color: rgba(0, 0, 0, 0.7);
        z-index: 999;
        width: 100%;
        height: 100%;
        cursor: pointer;

        .popup-content-shell {
            background-color: #fff;
            border-radius: 8px;
            cursor: text;

            .popup-title {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 60px;
                border-bottom: 1px solid #dcdee0;
                font-weight: 600;
                font-size: 20px;
            }

            .applet-img {
                width: 300px;
                height: 300px;
                margin: 30px auto;
                display: block;
            }
            .ass-nav {
              text-align: center;
              font-size: 22px;
              font-weight: bold;
              margin-bottom: 15px;
            }
            .ass-msg,
            .ass-title {
              width: 500px;
              margin: 0 30px 15px;
            }
            .ass-title {
              word-break: break-all;
              span {
                font-weight: bold;
              }
            }
            .ass-msg {
              span {
                color: red;
              }
            }
            .ass-btn {
              width: 200px;
              height: 40px;
              border-radius: 20px;
              line-height: 40px;
              text-align: center;
              margin: 15px auto;
              background-color: #2AA9B5;
              color: #fff;
              cursor: pointer;
            }
        }
    }

    .coupon-tab-list {
        display: flex;
        align-items: center;
        height: 76px;
        border-bottom: 1px solid #DCDCDC;
        width: 958px;
        padding: 0 40px;

        .coupon-tab-box {
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 72px;
            height: 100%;
            font-size: 22px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #666666;
            margin-left: 47px;
            cursor: pointer;
        }

        .coupon-tab-box-active {
            color: #2AA9B5;
            position: relative;

            &:after {
                position: absolute;
                bottom: 0px;
                left: 50%;
                transform: translateX(-50%);
                content: "";
                width: 110%;
                height: 5px;
                background: #2AA9B5;
                border-radius: 3px;
            }
        }
    }

    .course-list {
        .course-box1, .goods-box {
            display: flex;
            align-items: center;
            min-height: 228px;
            padding: 0 30px;
            border-bottom: 1px solid #DCDCDC;

            .course-img {
                margin-right: 20px;

                img {
                    width: 274px;
                    height: 165px;
                }
            }

            .course-info {
                min-width: 391px;
                margin-right: 40px;


            }

            .goods-info {
                display: flex;
            }

            .goods-bottom-handle {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 10px;

                .course-bar-shell {
                    width: 50%;
                }

                .handle-list {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    width: 50%;
                    padding: 0 30px;
                }
            }

            .start-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 150px;
                height: 47px;
                background: #18949C;
                border-radius: 5px;
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                cursor: pointer;
            }

            .buy-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 150px;
                height: 47px;
                border: 1px solid #2AA9B5;
                border-radius: 5px;
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #2AA9B5;
                cursor: pointer;
            }
        }

        .goods-box {
            display: block;
            padding: 15px 30px;
        }

        .course-bar-tips {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #2AA9B5;
            margin-bottom: 6px;
        }

        .course-bar {
            width: 80%;
            height: 10px;
            background: #E5E5E5;
            border-radius: 5px;

            .bar {
                width: 114px;
                height: 10px;
                background: #2AA9B5;
                border-radius: 5px;
            }
        }

        .course-name {
            font-size: 22px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #000000;
            margin-bottom: 20px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            white-space: nowrap;
            -o-text-overflow: ellipsis; /* for Opera */
            text-overflow: ellipsis;
            overflow: hidden;
        }

        .course-price {
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #EB2020;
            margin-bottom: 16px;
        }

        .course-type, .course-time {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: rgba(153, 153, 153, 1);
            margin-bottom: 10px;

            span {
                color: #999999;
            }
        }
    }
</style>
